import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import './inputFormattedPhone.css';
import useTranslator from '../../../translation/hooks/useTranslator';

export const InputFormattedPhone = props => {
  const {
    setValue,
    field,
    index,
    // phoneTypes
    // const temporarily commented until backend give us the prop values translated, until then we're using phoneTypesHardcoded
    // TODO: Change phoneTypesHardcoded to phoneTypes again
  } = props;
  
  
  const { Translation } = useTranslator();

  // TODO: Remove this hardcoded and add "phoneTypes" prop again when backend retrieves the translated props
  const phoneTypesHardcoded = [
    {
        "Id": 1,
        "Name": Translation("FIELDS.PHONE_TYPE_COMERCIAL")
    },
    {
        "Id": 2,
        "Name": Translation("FIELDS.PHONE_TYPE_CELLPHONE")
    },
    {
        "Id": 3,
        "Name": Translation("FIELDS.PHONE_TYPE_RESIDENTIAL")
    },
    {
        "Id": 4,
        "Name": Translation("FIELDS.PHONE_TYPE_FAX")
    },
    {
        "Id": 5,
        "Name": Translation("FIELDS.PHONE_TYPE_OTHERS")
    }
]
  
  const maskOptions = [
    {
      pattern: null,
      label: Translation('FIELDS.WITHOUT_MASK'),
      img: '/assets/countries/none.png',
      alt: Translation('FIELDS.MASK_DROPDOWN.MASK_IMG_NONE_ALT'),
      countryId: null,
    },
    {
      pattern: '## ####-####',
      label: '99 9999-9999',
      img: '/assets/countries/ar.png',
      alt: Translation('FIELDS.MASK_DROPDOWN.MASK_IMG_ARG_ALT'),
      countryId: 32,
    },
    {
      pattern: '(##) ####?-####',
      label: '(99) 99999-9999',
      img: '/assets/countries/br.png',
      alt: Translation('FIELDS.MASK_DROPDOWN.MASK_IMG_BRA_ALT'),
      countryId: 76,
    },
    {
      pattern: '(##) #### ####',
      label: '(99) 9999 9999',
      img: '/assets/countries/cl.png',
      alt: Translation('FIELDS.MASK_DROPDOWN.MASK_IMG_CHL_ALT'),
      countryId: 152,
    },
    {
      pattern: '(###) ###-####',
      label: '(999) 999-9999',
      img: '/assets/countries/co.png',
      alt: Translation('FIELDS.MASK_DROPDOWN.MASK_IMG_COL_ALT'),
      countryId: 170,
    },
    {
      pattern: '? (##) ####-####',
      label: '9 (99) 9999-9999',
      img: '/assets/countries/mx.png',
      alt: Translation('FIELDS.MASK_DROPDOWN.MASK_IMG_MEX_ALT'),
      countryId: 484,
    },
    {
      pattern: '## ### ####',
      label: '99 999 9999',
      img: '/assets/countries/pe.png',
      alt: Translation('FIELDS.MASK_DROPDOWN.MASK_IMG_PER_ALT'),
      countryId: 604,
    },
    {
      pattern: '(###) ###-####',
      label: '(999) 999-9999',
      img: '/assets/countries/us.png',
      alt: Translation('FIELDS.MASK_DROPDOWN.MASK_IMG_USA_ALT'),
      countryId: 840,
    },
    {
      pattern: '# ### ####',
      label: '9 999 9999',
      img: '/assets/countries/uy.png',
      alt: Translation('FIELDS.MASK_DROPDOWN.MASK_IMG_URY_ALT'),
      countryId: 858,
    },
  ]
  
  const DEFAULT_INPUT_VALUES = { mask: maskOptions[0], pattern: maskOptions[0].pattern, invalid: false, maskDropdown: false, type: phoneTypesHardcoded[0], typeDropdown: false };
  const DEFAULT_PHONE_VALUES = {phone: '', mask: maskOptions[0].countryId, type: phoneTypesHardcoded[0].Id};
  const [valueArray, setValueArray] = useState([{ ...DEFAULT_PHONE_VALUES}]);
  const [phoneArray, setPhoneArray] = useState([{ ...DEFAULT_INPUT_VALUES }]);
  
  useEffect(() => {
    const isValid = !valueArray.find(v => v.invalid);
    setValue(!isValid ? null : valueArray, index, field.ObjectKey, field.Required, isValid, Translation('FIELDS.MASK_ERROR'));
  }, [valueArray]);

  const handleInputChange = useCallback(index => (values) => {
    const tempValueArray = [...valueArray];
    const { value, formattedValue } = values;

    if (tempValueArray[index] !== undefined && tempValueArray[index] !== null) {
      tempValueArray[index].phone = formattedValue.trim();
    } else {
      tempValueArray.push({...DEFAULT_PHONE_VALUES, phone: formattedValue.trim()})
    }

    if (value.length === 0 || !phoneArray[index].mask?.pattern || !formattedValue.includes('_')) {
      tempValueArray[index].invalid = false;
    } else {
      tempValueArray[index].invalid = true;
    }

    setValueArray([...tempValueArray]);
  }, [valueArray])

  const addToInputArray = useCallback(() => {
    const tempPhoneArray = [{ ...DEFAULT_INPUT_VALUES }, ...phoneArray];
    const tempValueArray = [{...DEFAULT_PHONE_VALUES}, ...valueArray];
    setPhoneArray([...tempPhoneArray]);
    setValueArray([...tempValueArray]);
  }, [phoneArray, valueArray])

  const removeFromInputArray = useCallback(index => (e) => {
    const tempPhoneArray = [...phoneArray.filter((v, i) => i !== index)];
    const tempValueArray = [...valueArray.filter((v, i) => i !== index)];
    setPhoneArray([...tempPhoneArray]);
    setValueArray([...tempValueArray]);
  }, [phoneArray, valueArray])

  const setMaskForPhone = useCallback((index, mask) => (e) => {
    const tempPhoneArray = [...phoneArray];
    const tempValueArray = [...valueArray];
    tempPhoneArray[index].mask = mask;
    tempPhoneArray[index].pattern = mask?.pattern?.replace('?', '#');
    tempValueArray[index].mask = mask.countryId;
    tempValueArray[index].phone = '';
    setPhoneArray([...tempPhoneArray]);
    setValueArray([...tempValueArray]);
  }, [phoneArray])

  const setTypeForPhone = useCallback((index, type) => (e) => {
    const tempPhoneArray = [...phoneArray];
    const tempValueArray = [...valueArray];
    tempPhoneArray[index].type = type;
    tempValueArray[index].type = type.Id;
    setPhoneArray([...tempPhoneArray]);
    setValueArray([...tempValueArray]);
  }, [phoneArray])

  const toggleMaskDropdown = useCallback((index) => (e) => {
    const tempPhoneArray = [...phoneArray];
    tempPhoneArray[index].maskDropdown = !tempPhoneArray[index].maskDropdown;
    setPhoneArray([...tempPhoneArray]);
  }, [phoneArray])

  const toggleTypeDropdown = useCallback((index) => (e) => {
    const tempPhoneArray = [...phoneArray];
    tempPhoneArray[index].typeDropdown = !tempPhoneArray[index].typeDropdown;
    setPhoneArray([...tempPhoneArray]);
  }, [phoneArray])

  const handleOnBlurPhoneInput = (index) => {
    const tempPhoneArray = [...phoneArray];
    const countryId = valueArray[index].mask;
    
    // For Brazil and Mexico, cellphones follow an 11-digit format. 
    // If the number is not a cellphone, switch to the 10-digit pattern.
    if (countryId === 484 || countryId === 76) {
      const phoneNumbers = valueArray[index].phone.replace(/\D/g, '');
      const shortPattern = phoneArray[index]?.mask?.pattern?.replace('?', '');

      if (phoneNumbers.length === shortPattern.replace(/[^#]/g, '').length && tempPhoneArray[index].pattern !== shortPattern) {
        tempPhoneArray[index].pattern = shortPattern;
        setPhoneArray([...tempPhoneArray]);
      }
    }
  }

  const handleOnFocusPhoneInput = (index) => {
    const tempPhoneArray = [...phoneArray];
    const longPattern = phoneArray[index]?.mask?.pattern?.replace('?', '#');

    // If on focus, show the 11 digit pattern
    if (phoneArray[index]?.pattern !== longPattern) {
      tempPhoneArray[index].pattern = longPattern;
      setPhoneArray([...tempPhoneArray]);
    }
  }

  return (
    <div className='form-content__phone-wrapper'>
      {phoneArray.map((input, index) => (
        <div className='form-content__phone-row' key={index}>
          <div className='form-content__phone-selector --left' onClick={toggleMaskDropdown(index)}>
            <img src={input.mask.img} alt={input.mask.alt} />
            {input.maskDropdown && <div className='form-content__phone-selector__dropdown'>
              <ul>
                {maskOptions.map(mask => (
                  <li onClick={setMaskForPhone(index, mask)}>
                    <img src={mask.img} alt={mask.alt} />
                    {mask.label}
                  </li>
                ))}
              </ul>
            </div>}
          </div>
          <NumberFormat
            className={`form-content__input ${input.invalid ? '--invalid' : ''}`}
            onValueChange={handleInputChange(index)}
            onFocus={() => handleOnFocusPhoneInput(index)}
            onBlur={() => handleOnBlurPhoneInput(index)}
            value={valueArray[index].phone}
            name={field.FieldKey}
            type='tel'
            mask={'_'}
            format={input?.pattern}
          />
          <div className='form-content__phone-selector --right' onClick={toggleTypeDropdown(index)}>
          {input.type?.Name && <div className='form-content__phone-type'>{input.type?.Name}</div>}
            {input.typeDropdown && <div className='form-content__phone-selector__dropdown'>
              <ul>
                {phoneTypesHardcoded.map(type => (
                  <li key={type.Id} onClick={setTypeForPhone(index, type)}>
                    {type.Name}
                  </li>
                ))}
              </ul>
            </div>}
          </div>
          <div className='form-content__phone-buttons'>
            {(phoneArray.length > 1) && <div className="form-content__phone-btn --minus" onClick={removeFromInputArray(index)}> - </div>}
            {(index === 0) && <div className="form-content__phone-btn" onClick={() => addToInputArray()}> + </div>}
          </div>
        </div>
      ))
      }
    </div>
  );
}

InputFormattedPhone.propTypes = {
  value: PropTypes.array,
  setValue: PropTypes.func.isRequired,
  field: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  validation: PropTypes.func,
  // phoneTypes: PropTypes.array, TODO: Add after removing hardcoded
  phoneTypesHardcoded: PropTypes.array
}